<template>
  <ct-footer :version="version" breakpoint="is-widescreen" />
</template>

<script>
export default {
  name: 'TheFooter',

  computed: {
    version () {
      return require('../../package.json').version
    }
  }
}
</script>
